import React from "react";
import "./Footer.css";
import { useLocalContext } from "../../context/LocalContext";

const Footer = () => {
  const { webinfo = {} } = useLocalContext();
  const year = new Date().getFullYear();

  return (
    <footer className="ft-blue">
      <div className="ft-wrap">
        <div className="ft-top">

          {/* BRAND */}
          <section className="ft-brand">
            <div className="ft-logo">
              {webinfo.logowhite ? (
                <img src={webinfo.logowhite} alt={webinfo.name || "Brand"} />
              ) : (
                <h2 className="ft-brand-text">
                  {webinfo.name || "digivirtuehost.com"}
                </h2>
              )}
            </div>

            <p className="ft-desc">
              Reliable web hosting for sites and apps — shared, WordPress, and
              VPS — with migrations, DNS, SSL, and support that speaks plainly.
            </p>

            <div className="ft-tags">
              <span>SSD infrastructure</span>
              <span>Free SSL options</span>
              <span>24/7 support</span>
              <span>Migration help</span>
            </div>

            <form
              className="ft-news"
              onSubmit={(e) => {
                e.preventDefault();
                const email = e.target.email.value;
                window.location.href = `mailto:${webinfo.email}?subject=Subscribe&body=Add ${email}`;
              }}
            >
              <input
                name="email"
                type="email"
                placeholder="you@company.com"
                required
              />
              <button type="submit" className="ft-btn">
                Subscribe
              </button>
            </form>
          </section>

          {/* SERVICES */}
          <nav className="ft-col">
            <h4>Hosting</h4>
            <ul>
              <li><a href="/services">All products</a></li>
              <li><a href="/services/shared-hosting">Shared hosting</a></li>
              <li><a href="/services/wordpress-hosting">WordPress</a></li>
              <li><a href="/services/vps-hosting">VPS & cloud</a></li>
              <li><a href="/process">How it works</a></li>
            </ul>
          </nav>

          {/* COMPANY */}
          <nav className="ft-col">
            <h4>Company</h4>
            <ul>
              <li><a href="/about">About</a></li>
              <li><a href="/our-strategies">Why us</a></li>
              <li><a href="/contact">Contact</a></li>
              <li><a href="/services">Plans</a></li>
            </ul>
          </nav>

          {/* CONTACT */}
          <section className="ft-contact">
            <h4>Contact</h4>
            <div className="ft-card">
              <div className="ft-row">
                <span className="ft-k">EMAIL</span>
                <a className="ft-v" href={`mailto:${webinfo.email}`}>
                  {webinfo.email || "contact@digivirtuehost.com"}
                </a>
              </div>

              <div className="ft-row">
                <span className="ft-k">PHONE</span>
                <a className="ft-v" href={`tel:${webinfo.phonecall}`}>
                  {webinfo.phone || "+91 80000 00000"}
                </a>
              </div>

              <div className="ft-row">
                <span className="ft-k">HOURS</span>
                <span className="ft-v">
                  {webinfo.hours || "Mon–Sat · 10am–7pm IST"}
                </span>
              </div>

              <div className="ft-social">
                <a href={webinfo.linkedin || "#"}>in</a>
                <a href={webinfo.twitter || "#"}>X</a>
                <a href={webinfo.instagram || "#"}>IG</a>
              </div>
            </div>
          </section>

        </div>

        {/* BOTTOM */}
        <div className="ft-bottom">
          <p>© {year} {webinfo.name || "digivirtuehost.com"}. All rights reserved.</p>
          <div className="ft-legal">
            <a href="/terms-and-condition">Terms</a>
            <a href="/privacy-policy">Privacy</a>
            <a href="/disclaimer">Disclaimer</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
